import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.538 9.211h3.47v5.58l.06 4.173H8.733v-4.173l-1.196.002c-3.384 0-3.384-5.582 0-5.582Z" }),
    React.createElement("path", { d: "m17.233 17.738-3.469-2.947h-1.297v-5.58h1.298l3.468-2.946 1.425-1.208c.122-.118.343-.04.343.124v13.64c-.003.157-.206.242-.334.133l-1.434-1.216Z" })));
export default createSvgIcon(iconPath, "Campaigns");
//# sourceMappingURL=CampaignsIcon.js.map